import * as React from "react";
const SvgPen = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: 20,
    height: 20,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M13.9998 5.99985L17.9998 9.99985M4.17654 20.7645L6.0997 20.3799C6.80597 20.2386 7.15911 20.168 7.4884 20.0388C7.78068 19.9242 8.05845 19.7755 8.31597 19.5959C8.6061 19.3936 8.86075 19.1389 9.37005 18.6296L19.8685 8.13122C20.2645 7.7352 20.4625 7.53719 20.5367 7.30887C20.6019 7.10802 20.6019 6.89168 20.5367 6.69083C20.4625 6.4625 20.2645 6.2645 19.8685 5.86848L18.1312 4.13122C17.7352 3.7352 17.5372 3.53719 17.3089 3.46301C17.108 3.39775 16.8917 3.39775 16.6908 3.46301C16.4625 3.53719 16.2645 3.7352 15.8685 4.13122L5.37005 14.6296C4.86075 15.1389 4.6061 15.3936 4.40376 15.6837C4.22416 15.9412 4.0755 16.219 3.96085 16.5113C3.83169 16.8406 3.76107 17.1937 3.61981 17.9L3.23518 19.8232C3.15649 20.2166 3.11715 20.4133 3.1752 20.5536C3.22595 20.6763 3.3234 20.7737 3.44607 20.8245C3.58638 20.8825 3.7831 20.8432 4.17654 20.7645Z",
      stroke: "currentColor",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
);
export default SvgPen;
